/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Progress_Lifts_Chart_LabelInputs */

const en_us2_progress_lifts_chart_label = /** @type {(inputs: Progress_Lifts_Chart_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estimated max strength per week`)
};

const pt_br2_progress_lifts_chart_label = /** @type {(inputs: Progress_Lifts_Chart_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Força máxima estimada por semana`)
};

const es_419_progress_lifts_chart_label = /** @type {(inputs: Progress_Lifts_Chart_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fuerza máxima estimada por semana`)
};

const pt_pt2_progress_lifts_chart_label = /** @type {(inputs: Progress_Lifts_Chart_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Força máxima estimada por semana`)
};

const fr_fr2_progress_lifts_chart_label = /** @type {(inputs: Progress_Lifts_Chart_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Force max estimée par semaine`)
};

const de_de2_progress_lifts_chart_label = /** @type {(inputs: Progress_Lifts_Chart_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geschätzte Maximalkraft pro Woche`)
};

const it_it2_progress_lifts_chart_label = /** @type {(inputs: Progress_Lifts_Chart_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Forza massima stimata per settimana`)
};

/**
* | output |
* | --- |
* | "Estimated max strength per week" |
*
* @param {Progress_Lifts_Chart_LabelInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const progress_lifts_chart_label = /** @type {((inputs?: Progress_Lifts_Chart_LabelInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Progress_Lifts_Chart_LabelInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_progress_lifts_chart_label(inputs)
	if (locale === "es-419") return es_419_progress_lifts_chart_label(inputs)
	if (locale === "pt-PT") return pt_pt2_progress_lifts_chart_label(inputs)
	if (locale === "fr-FR") return fr_fr2_progress_lifts_chart_label(inputs)
	if (locale === "de-DE") return de_de2_progress_lifts_chart_label(inputs)
	if (locale === "it-IT") return it_it2_progress_lifts_chart_label(inputs)
	return en_us2_progress_lifts_chart_label(inputs)
});
export { progress_lifts_chart_label as "progress.lifts_chart_label" }